import React, { Dispatch, SetStateAction, useCallback } from "react";
import { observer } from "mobx-react-lite";
import { URLHOST } from "../../../Const/envConst";
import AuthStore from "../../../../old/Store/AuthStore";
import { Link, useLocation, useNavigate } from "react-router-dom";
import * as ST from "./styled";
import { useMediaQuery } from "../../../Hooks/useMediaQuery";
import BreakPoints from "src/general/constants/breakPoints";
import { Phones } from "../Telephone";
import Typography from "@mui/material/Typography";

interface Open {
	fullName?: string | null;
	setMenuState: Dispatch<SetStateAction<boolean>>;
}

const Entrance = observer<Open>(({ fullName, setMenuState }) => {
	const nameCurren = AuthStore.name;
	const surname = AuthStore.surname;
	const email = AuthStore.email;

	const cutSurname = surname?.slice(0, 1).toUpperCase();

	const navigate = useNavigate();
	const location = useLocation();
	const isLkPageOpen =
		location.pathname === "/lk" ||
		location.pathname === "/lk/" ||
		location.pathname === "/lk/auth";

	const routeBtnLkPage = () => {
		navigate("/lk/");
	};

	const handleMenuOpen = useCallback(() => {
		setMenuState((prevState) => !prevState);
	}, [setMenuState]);

	const name =
		nameCurren && cutSurname
			? nameCurren === "null" || cutSurname === "null"
				? email || undefined
				: `${nameCurren} ${cutSurname}.`
			: undefined;

	const isMobile = useMediaQuery(`(max-width: ${BreakPoints.TABLET_1023}px)`);

	return (
		<ST.Container>
			<ST.PhonesWrapper>
				<Phones />
			</ST.PhonesWrapper>
			{!name && !fullName ? (
				<ST.Link href={`${URLHOST}/lk/auth`}>
					<ST.Entrance>
						<Typography
							variant="body1"
							color="primary.main"
						>
							Войти в ЛК
						</Typography>
					</ST.Entrance>
				</ST.Link>
			) : isMobile ? (
				<ST.Link onClick={handleMenuOpen}>
					<ST.Entrance>
						<Typography
							variant="body1"
							color="primary.main"
						>
							{name ?? fullName}
						</Typography>
					</ST.Entrance>
				</ST.Link>
			) : (
				<ST.InactiveLink
					isLkPageOpen={isLkPageOpen}
					onClick={routeBtnLkPage}
				>
					<Link to={"/"}>
						<ST.Entrance>
							<Typography
								variant="body1"
								color="primary.main"
							>
								 {name ?? fullName}
							</Typography>
						</ST.Entrance>
					</Link>
				</ST.InactiveLink>
			)}
		</ST.Container>
	);
});

export default Entrance;
